<script>
import {useEvaluationFileStore} from "@/stores/Evaluation/EvaluationFile";
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        multiple: Boolean,
        label: String,
        readonly: Boolean,
        notClearable: Boolean,
        useLocalCache: Boolean,
        rules: Array,
        type: String,
        cycle: String,
    },
    setup(props) {
        const evaluationFileStore = useEvaluationFileStore();
        const {loading, inputColor, backgroundColor} = useSharedData();
        const evaluationFile = ref(null);
        const evaluationFiles = ref([]);

        function findAll() {
            loading.value = true;
            // emit('input', []);
            axios.get('/evaluationFiles', {
                params: {
                    type: props.type,
                    cycle: props.cycle,
                }
            }).then(response => {
                if(props.useLocalCache) {
                    evaluationFiles.value = response.data;
                } else {
                    evaluationFileStore.setEvaluationFiles(response.data);
                }
            }).finally(() => {
                loading.value = false;
            })
        }

        watch(() => props.value, () => {
            evaluationFile.value = props.value;
        }, {immediate: true});

        watch(() => props.cycle, () => {
            findAll();
        }, {immediate: true});

        return {
            evaluationFileStore,
            evaluationFile,
            evaluationFiles,
            loading,
            inputColor,
            backgroundColor
        }
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="evaluationFile"
            :label="label"
            :items="useLocalCache ? evaluationFiles : evaluationFileStore.evaluationFiles"
            item-value="id"
            item-text="name"
            outlined
            dense
            :loading="loading"
            :readonly="readonly"
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', evaluationFile)"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>